var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { createPortal } from 'react-dom';
export var DynamicPortal = function (_a) {
    var children = _a.children, style = _a.style;
    var PortalElement = function () {
        return (_jsx("div", __assign({ id: "root-portal", style: style }, { children: children })));
    };
    return createPortal(_jsx(PortalElement, {}), document.body);
};
DynamicPortal.displayName = 'DynamicPortal';
